// extracted by mini-css-extract-plugin
export default {"login":"Login_login__4rE5+","loffaLogo":"Login_loffaLogo__gL9zt","versionHeader":"Login_versionHeader__mFv9H"};